angular.module('MyHippoProducer.Services').factory('FlagshipService', function ($http, UserService) {
    const {
        FLAGSHIP_API_KEY,
        FLAGSHIP_ENV_ID,
        FLAGSHIP_CAMPAIGN_ID
    } = window.appConfig;

    const buildRequestBody = ({ producerId, organizationId, parentOrganizationId, rootOrganizationId } = {}) => ({
        visitor_id: producerId || UserService.getId(),
        context: {
            'organization_id': organizationId || (UserService.getOrgId() ? UserService.getOrgId().toString() : ''),
            'parent_organization_id': parentOrganizationId || (UserService.getParentOrgId() ? UserService.getParentOrgId().toString() : ''),
            'root_organization_id': rootOrganizationId || (UserService.getRootOrgId() ? UserService.getRootOrgId().toString() : ''),
        },
    });

    const buildHeaders = () => ({
        'Content-Type': 'application/json',
        'x-api-key': FLAGSHIP_API_KEY,
        'Cache-Control': undefined
    });

    const getCampaignData = (
        { campaignID,
            producerId,
            organizationId,
            parentOrganizationId,
            rootOrganizationId
        }) => {

        return $http({
            url: `https://decision.flagship.io/v2/${FLAGSHIP_ENV_ID}/campaigns/${campaignID ? campaignID: FLAGSHIP_CAMPAIGN_ID}`, // default campaign to react
            method: 'POST',
            params: { mode: 'simple' },
            data: buildRequestBody({ producerId, organizationId, parentOrganizationId, rootOrganizationId }),
            headers: buildHeaders(),
            withCredentials: false
        });
    };

    const getAllFlags = ({ producerId,
        organizationId,
        parentOrganizationId,
        rootOrganizationId
    } = {}) => {
        return $http({
            url: `https://decision.flagship.io/v2/${FLAGSHIP_ENV_ID}/flags`,
            method: 'POST',
            data: buildRequestBody({ producerId, organizationId, parentOrganizationId, rootOrganizationId }),
            headers: buildHeaders(),
            withCredentials: false,
            params: { exposeAllKeys: false }
        });
    };

    return { getCampaignData, getAllFlags };
});
